import { useEffect, useState } from "react"
import { Button, Icon, Label, Table } from "semantic-ui-react"

import { MobileMoney } from "../../models"
import { MobileMoneyServiceService } from "../../services"
import { SupervisorMobileMoneyServiceCreateForm, NoData, ErrorMessage, LoadingSpinner } from "../../components"
import { FeedbackMessage } from "../../constants"


export function SupervisorMobileMoneyPage() {

    const [mobileMoneyServices, setMobileMoneyServices] = useState<MobileMoney[]>([])
    const [loadingMobileMoneyServices, setLoadingMobileMoneyServices] = useState(true)
    const [errorFetchingMobileMoneyServices, setErrorFetchingMobileMoneyServices] = useState(false)
    const [createModalVisible, setCreateModalVisible] = useState(false)

    const addToList = (service: MobileMoney) => setMobileMoneyServices([...mobileMoneyServices, service])

    useEffect(() => {
        MobileMoneyServiceService.getMobileMoneyServices('sup')
            .then(data => setMobileMoneyServices(data))
            .catch(() => setErrorFetchingMobileMoneyServices(true))
            .finally(() => setLoadingMobileMoneyServices(false))
    }, [])

    return <div>
        { loadingMobileMoneyServices && <LoadingSpinner />}
        { errorFetchingMobileMoneyServices && <ErrorMessage errorText={FeedbackMessage.SERVICE_FETCH_ERROR} />}
        { !loadingMobileMoneyServices && !errorFetchingMobileMoneyServices &&
        <div>
            <div className='headerRow'>
                <div className='flex-center'>
                    <h3 className='mb-0 mr-25'>
                        <Label color='orange'>{mobileMoneyServices.length}</Label> &nbsp; Services mobile money
                    </h3>
                </div>
                <Button color='orange' className='size-16' onClick={() => setCreateModalVisible(true)}>
                    <Icon name="add circle" />Nouveau
                </Button>
            </div>
            {
                mobileMoneyServices.length === 0 ? <NoData /> :
                <Table basic="very">
                    <Table.Header>
                        <Table.Row>
                            <Table.HeaderCell className="size-17">N°</Table.HeaderCell>
                            <Table.HeaderCell className="size-17">Logo</Table.HeaderCell>
                            <Table.HeaderCell className="size-17">Nom</Table.HeaderCell>
                            <Table.HeaderCell className="size-17">Type</Table.HeaderCell>
                            <Table.HeaderCell className="size-17">Banque Payeur</Table.HeaderCell>
                            <Table.HeaderCell className="size-17">Actions</Table.HeaderCell>
                        </Table.Row>
                    </Table.Header>
                    <Table.Body>
                        {mobileMoneyServices.map(service => <Table.Row key={service.id}>
                            <Table.Cell>{service.id}</Table.Cell>
                            <Table.Cell><img src={'/images/' + service.logo} alt='' width='50' className='radius-4'/></Table.Cell>
                            <Table.Cell>{service.name}</Table.Cell>
                            <Table.Cell>{service.type}</Table.Cell>
                            <Table.Cell>{service.bank}</Table.Cell>
                            <Table.Cell>
                                <Button icon className='mr-10'><Icon name='trash alternate' /></Button>
                                <Button icon className='mr-10'><Icon name='pencil alternate' /></Button>
                            </Table.Cell>
                        </Table.Row>)}
                    </Table.Body>
                </Table>
            }
        </div>
        }

        { createModalVisible && <SupervisorMobileMoneyServiceCreateForm setCreateModalVisible={setCreateModalVisible} addMobileMoneyServiceToList={addToList}/> }
    </div>
}


// kmrbBAjh
// 777574508